
import { mapState } from "vuex";

export default {
  data() {
    return {
      orderData: [
        { label: "Order ID", data: "source_id" },
        { label: "Stage", data: "status" },
        { label: "Duration", data: "duration" },
        { label: "Ordered by", data: "customer_name" },
        { label: "Contact No.", data: "customer_mobile" },
        { label: "Deliver to", data: "delivery_address" },
        { label: "Payment", data: "mode" }
      ]
    };
  },
  props: {
    orderDetails: {}
  },
  computed: {}
};
